
import { defineComponent, ref, computed, inject, watch } from "vue";
import { store } from "@/store";
import Accordian from "@/components/SideToolBar/Accordian.vue";
import { onBoardingTextRef, onBoardingImageRef, onBoardingSettingsRef } from "@/onboarding/Refs";
import { AccordianState, ClientDimensions } from "@/types";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "SideToolBar",
  components: {
    Accordian,
  },
  data() {
    return {
      tool: "",
    };
  },
  setup() {
    const lockToolBar = inject<boolean>("lockToolBar");

    const isPrintedSheetLabel = computed<boolean>(() =>
      store.getters.currentLabelType === "printed" || store.getters.currentLabelType === "blank"
        ? true
        : false
    );
    const isMobile = computed<boolean>(() => store.getters.isMobile);

    /* ONBOARDING */
    const showOnboarding = computed<boolean>(() => store.getters.showOnboarding);
    watch(showOnboarding, (onboarding: boolean) => {
      if (!onboarding) {
        onboardingWasClosed();
      }
    });

    const helpRef = ref<HTMLDivElement>();
    const onboardingWasClosed = () => {
      if (helpRef.value) {
        helpRef.value.classList.add("pulseAnim");

        setTimeout(() => {
          helpRef.value?.classList.remove("pulseAnim");
        }, 2500);
      }
    };
    /* ONBOARDING */

    /* HELP */
    const openHelp = () => {
      store.dispatch(ActionTypes.SET_MODAL, "help");
    }
    /* HELP */

    return {
      onBoardingTextRef,
      onBoardingImageRef,
      onBoardingSettingsRef,
      isPrintedSheetLabel,
      isMobile,
      lockToolBar,
      helpRef,
      openHelp
    };
  },
  computed: {
    accordianState(): AccordianState {
      return this.$store.getters.accordianState;
    },
    clientDimensions(): ClientDimensions {
      return this.$store.getters.clientDimensions;
    },
  },
  methods: {
    setAccordianState(tool: string): void {
      if (this.lockToolBar) return;

      if (tool === this.accordianState.tool) {
        const PAYLOAD: AccordianState = { isOpen: false, tool: "", key: 0 };

        this.$store.dispatch(ActionTypes.SET_ACCORDIAN_STATE, PAYLOAD);
      } else {
        const PAYLOAD: AccordianState = { isOpen: true, tool: tool, key: 0 };

        this.$store.dispatch(ActionTypes.SET_ACCORDIAN_STATE, PAYLOAD);
      }
    },
  },
  watch: {
    accordianState(newState: AccordianState, oldState: AccordianState) {
      let newTool = newState.tool;
      let oldTool = oldState.tool;

      if (newTool === oldTool) {
        return;
      }

      if (this.isMobile) {
        switch (newTool) {
          case "Text":
          case "Settings": {
            let container = document.querySelector(`#${newTool.toLowerCase()}`);
            container!.setAttribute("style", "fill: rgb(7, 205, 234);");

            let left = container!.getBoundingClientRect().left;
            let overlay = document.querySelector(`.select-overlay`);
            overlay!.setAttribute(
              "style",
              `opacity: 1; left: ${left}px; transition: opacity .5s, left .25s ease;`
            );

            let icon = document.querySelector(`#${newTool.toLowerCase()} .tool-icon`);
            icon!.setAttribute("style", "color: rgb(7, 205, 234); fill: rgb(7, 205, 234);");

            let label = document.querySelector(`#${newTool.toLowerCase()} .tool-label`);
            label!.setAttribute("style", "color: rgb(7, 205, 234);");
            break;
          }
          default: {
            if (newTool.length) {
              let container = document.querySelector(`#${newTool.toLowerCase()}`);
              container!.setAttribute("style", "fill: rgb(7, 205, 234);");

              let left = container!.getBoundingClientRect().left;
              let overlay = document.querySelector(`.select-overlay`);
              overlay!.setAttribute(
                "style",
                `opacity: 1; left: ${left}px; transition: opacity .5s, left .25s ease;`
              );

              let icon = document.querySelector(`#${newTool.toLowerCase()} .tool-icon`);
              icon!.setAttribute("style", "color: rgb(7, 205, 234); fill: rgb(7, 205, 234);");

              let label = document.querySelector(`#${newTool.toLowerCase()} .tool-label`);
              label!.setAttribute("style", "color: rgb(7, 205, 234);");
            } else {
              let overlay = document.querySelector(`.select-overlay`);
              let left = overlay!.getBoundingClientRect().left;
              overlay!.setAttribute(
                "style",
                `opacity: 0; left: ${left}px; transition: opacity .5s;`
              );
            }
            break;
          }
        }
      } else {
        switch (newTool) {
          case "Text":
          case "Settings": {
            let container = document.querySelector(`#${newTool.toLowerCase()}`);
            container!.setAttribute("style", "fill: rgb(7, 205, 234);");
            //-60 because of the top nav bar having 60px of height
            //boundingRect is getting height relative to entire client
            //we are setting height relative to side-tool-bar-component
            let top = container!.getBoundingClientRect().top - 60;

            let overlay = document.querySelector(`.select-overlay`);
            overlay!.setAttribute(
              "style",
              `opacity: 1; top: ${top}px; transition: opacity .5s, top .25s ease;`
            );

            let icon = document.querySelector(`#${newTool.toLowerCase()} .tool-icon`);
            icon!.setAttribute("style", "color: rgb(7, 205, 234); fill: rgb(7, 205, 234);");

            let label = document.querySelector(`#${newTool.toLowerCase()} .tool-label`);
            label!.setAttribute("style", "color: rgb(7, 205, 234);");
            break;
          }
          default: {
            if (newTool.length) {
              let container = document.querySelector(`#${newTool.toLowerCase()}`);
              container!.setAttribute("style", "fill: rgb(7, 205, 234);");

              let top = container!.getBoundingClientRect().top - 60;
              let overlay = document.querySelector(`.select-overlay`);
              overlay!.setAttribute(
                "style",
                `opacity: 1; top: ${top}px; transition: opacity .5s, top .25s ease;`
              );

              let icon = document.querySelector(`#${newTool.toLowerCase()} .tool-icon`);
              icon!.setAttribute("style", "color: rgb(7, 205, 234); fill: rgb(7, 205, 234);");

              let label = document.querySelector(`#${newTool.toLowerCase()} .tool-label`);
              label!.setAttribute("style", "color: rgb(7, 205, 234);");
            } else {
              let overlay = document.querySelector(`.select-overlay`);
              let top = overlay!.getBoundingClientRect().top - 60;
              overlay!.setAttribute("style", `opacity: 0; top: ${top}px; transition: opacity .5s;`);
            }
            break;
          }
        }
      }

      switch (oldTool) {
        case "Text":
        case "Settings": {
          let icon = document.querySelector(`#${oldTool.toLowerCase()} .tool-icon`);
          icon!.setAttribute("style", "");
          let label = document.querySelector(`#${oldTool.toLowerCase()} .tool-label`);
          label!.setAttribute("style", "");
          break;
        }
        default: {
          if (oldTool.length) {
            let icon = document.querySelector(`#${oldTool.toLowerCase()} .tool-icon`);
            icon!.setAttribute("style", "");
            let label = document.querySelector(`#${oldTool.toLowerCase()} .tool-label`);
            label!.setAttribute("style", "");
          }
          break;
        }
      }
    },
  },
});
